import {
  domScriptInjectAsync,
  REACT_APP__GET_SITE_CONTROL_KEY,
} from "@smp/utils";
import { useMount } from "react-use";

export const useGscInit = () =>
  useMount(() => {
    if (import.meta.env.MODE === "development") {
      return;
    }

    (async () => {
      await domScriptInjectAsync(
        "//l.getsitecontrol.com/" + REACT_APP__GET_SITE_CONTROL_KEY + ".js",
      );
    })();

    window.gsc =
      window.gsc ||
      (function () {
        if (window.gsc) {
          (window.gsc.q = window.gsc.q || []).push(arguments);
        }
      } as any);
  });
